export const getRevertOptionKey = (opt) => `${opt.type}-${opt.value}`;

const STATUS_DESCRIPTIONS = {
  'Awaiting Approval': 'Return to awaiting approval',
  Approved: 'Return to approved status',
  'Pre-Production': 'Move job back to pre-production',
  Production: 'Move job back to production',
  'Staged Install': 'Move job back to staged install',
};

export const getRevertOptionDescription = (opt) =>
  STATUS_DESCRIPTIONS[opt.label] || 'Revert to this status';

export function buildRevertStatusOptions({
  isQuotation,
  currentQS,
  currentSt,
  currentProjStatus,
  hasProject,
  isStagedOrInstalling = false,
  installationStatus,
  allInstallationCompleted = false,
}) {
  if (isQuotation) {
    if (currentQS === 9) {
      return [{ label: 'Awaiting Approval', value: 4, type: 'quotation' }];
    }
    if ([4, 6, 3].includes(currentQS)) {
      return [];
    }
    return [];
  }

  const options = [];

  if (currentSt === 4) {
    options.push({ label: 'Approved', value: 3, type: 'request' });

    if (hasProject && currentProjStatus === 2) {
      options.push({ label: 'Pre-Production', value: 1, type: 'project' });
    } else if (hasProject && currentProjStatus === 3) {
      options.push(
        { label: 'Production', value: 2, type: 'project' },
        { label: 'Pre-Production', value: 1, type: 'project' },
      );
    } else if (isStagedOrInstalling) {
      options.push(
        { label: 'Production', value: 2, type: 'project' },
        { label: 'Pre-Production', value: 1, type: 'project' },
      );
    }

    // Completed (4) or Installing (2) → Staged Install (installation-only revert)
    if ([4].includes(Number(installationStatus)) || allInstallationCompleted) {
      options.push({ label: 'Staged Install', value: 1, type: 'installation' });
    }
  }

  return options;
}
